// src/app/services/adpGage.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IAdpGage, IAdpGageParams, UpdatePayload } from '../models';

export const adpGageApi = createApi({
  reducerPath: 'adpGageApi',
  baseQuery,
  endpoints: (builder) => ({
    getAdpGageParams: builder.query<{ adp_gage: IAdpGageParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/adp_gages/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getAdpGage: builder.query<IAdpGage, number>({
      query: (id) => `/api/v1.0/ahu/adp_gages/${id}`,
      transformResponse: (data: IAdpGage) => {
        data.params = data.adp_gage_params
          ? JSON.parse(data.adp_gage_params)
          : {};
        return data;
      },
    }),
    getAllAdpGagesCount: builder.query<{ count: number }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/adp_gages/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getAdpGagesCount: builder.query<{ count: number }, string>({
      query: (queryString) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/adp_gages/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    updateAdpGage: builder.mutation<IAdpGage, UpdatePayload<IAdpGage>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/adp_gages/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
      transformResponse: (data: IAdpGage) => {
        data.params = data.adp_gage_params
          ? JSON.parse(data.adp_gage_params)
          : {};
        return data;
      },
    }),
  }),
});

export const {
  useLazyGetAdpGageQuery,
  useGetAdpGageParamsQuery,
  useGetAllAdpGagesCountQuery,
  useLazyGetAdpGagesCountQuery,
  useGetAdpGageQuery,
  useUpdateAdpGageMutation,
} = adpGageApi;
